import { ProjectProps } from "@/interfaces/project_types";
import { useNavigate } from "react-router-dom";
import { ProjectCard } from "./ProjectCard";

/**
 * Renders all projects due on a specific day for the monthly calendar
 * @param projects list of projects on a specific day
 */

export function ListProjectsOnDay({ projects }: { projects: ProjectProps[]; }) {
    const navigate = useNavigate();

    return (
        <>
            {projects.map((project) => (
                <ProjectCard project={project} navigate={navigate} key={project.project_id} />
            ))}
        </>
    );
}
